import { useState, useCallback, useEffect } from "react";
import '../css/Usuarios.css';
import '../css/rotating-icon.css';
import { ReactComponent as Recargar } from '../assets/icon/recargar.svg';
import TablaUsuarios from "../Usuarios/TablaUsuarios";
import { useUsuarios } from '../services/usuarios';
import { useToast } from '../contexts/ToastContext';

function Usuarios() {
  const [currentPage, setCurrentPage] = useState(1);
  const { showError } = useToast();
  
  const { data: usuarios, loading, error, refetch } = useUsuarios({
    immediate: true
  });

  useEffect(() => {
    if (error) {
      showError(error, 'Error de conexión');
    }
  }, [error, showError]);

  const handlePageChange = useCallback((newPage) => {
    setCurrentPage(newPage);
  }, []);

  const handleRefresh = useCallback(() => {
    refetch();
  }, [refetch]);

  return (
    <div className="bodyUsuarios">

      {/* TÍTULO */}
      <div className='tituloUsuarios'><p>Usuarios</p></div>

      {/* CONTENIDO SUPERIOR */}
      <div className='contenidoSuperiorUsuarios'>
        <div className='botonesUsuarios'>
          <button 
            className='botonesEdicionUsuarios'
            onClick={handleRefresh}
            disabled={loading}
            title="Recargar usuarios"
          >
            <div className="svgBotonesUsuarios">
              <Recargar className={`logo-svgBotones ${loading ? 'rotating' : ''}`} />
            </div>
            Recargar
          </button>
        </div>
      </div>

      {/* AQUÍ SE MOSTRARÁ LA TABLA */}
      <div className="tablaContainerUsuarios">
        <TablaUsuarios 
          usuarios={usuarios}
          loading={loading}
          error={error}
          onRetry={refetch}
          emptyStateNoReload={true}
          pageSize={20}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      </div>

    </div>
  );
}

export default Usuarios;
